import React, { createContext, useContext, useEffect, useState, useCallback, useRef } from 'react';
import api from '../api';

const PresenceContext = createContext(null);

const PING_MS = 60000; // heartbeat ogni 60s

function hasToken() {
  return !!(localStorage.getItem('token') || sessionStorage.getItem('token'));
}

export function PresenceProvider({ children }) {
  const [online, setOnline] = useState(() => new Set());
  const timer = useRef(null);

  const tick = useCallback(async () => {
    if (!hasToken()) return;
    try {
      await api.post('/presence/ping', null, { silent: true });
      const res = await api.get('/presence', { silent: true });
      setOnline(new Set(res.data?.online || []));
    } catch { /* offline: ignora */ }
  }, []);

  useEffect(() => {
    tick();
    timer.current = setInterval(tick, PING_MS);
    const onVisible = () => { if (document.visibilityState === 'visible') tick(); };
    document.addEventListener('visibilitychange', onVisible);
    return () => { clearInterval(timer.current); document.removeEventListener('visibilitychange', onVisible); };
  }, [tick]);

  const isOnline = useCallback((id) => online.has(String(id)), [online]);

  return (
    <PresenceContext.Provider value={{ online, isOnline }}>
      {children}
    </PresenceContext.Provider>
  );
}

export const usePresence = () => useContext(PresenceContext) || { online: new Set(), isOnline: () => false };
